import type { SearchFormState } from '../../SearchFormLegacy/context';

/** Determine if the search is a one-way trip or a round trip. */
export const isOneWay = (state: SearchFormState | null): boolean => {
  if (!state?.depLocation || !state?.destLocation) {
    return false;
  }

  const { cityCode: depCityCode } = state.depLocation;
  const { cityCode: destCityCode } = state.destLocation;

  return depCityCode !== destCityCode;
};
